import { alpha } from '@mui/material';
import basicTheme from '../basicTheme.js';

const switchStyleOverride = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            display: 'flex',
            alignItems: 'center',
            opacity: '1',
            '&.Mui-checked': {
                '.MuiSwitch-track': {
                    backgroundColor: basicTheme.palette.primary.main,
                },
            },
            '&.MuiSwitch-sizeMedium': {
                width: 'fit-content',
                height: '27px',
            },
            '&.MuiSwitch-sizeSmall': {
                height: '18px',
                '.Mui-disabled': {
                    '&:hover': {
                        backgroundColor: 'transparent !important',
                    },
                },
                '&:hover': {
                    backgroundColor: alpha(basicTheme.palette.primary.main, 0.2),
                },
            },
        },
        switchBase: {
            cursor: 'pointer',
            padding: 0,
            '&:hover': {
                backgroundColor: `${alpha(basicTheme.palette.primary.main, 0.2)} !important`,
            },
            '&.Mui-checked': {
                '.MuiSwitch-thumb': {
                    borderColor: basicTheme.palette.primary.dark,
                },
                '+.MuiSwitch-track': {
                    backgroundColor: basicTheme.palette.primary.main,
                },
                '&.Mui-disabled': {
                    '.MuiSwitch-thumb': {
                        borderColor: basicTheme.palette.N30.main,
                    },
                    '+.MuiSwitch-track': {
                        backgroundColor: basicTheme.palette.primary.dark,
                    },
                },
            },
            '&.Mui-disabled': {
                opacity: '0.8',
                color: `${basicTheme.palette.N10.main} !important`,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
                '.MuiSwitch-thumb': {
                    borderColor: basicTheme.palette.N60.main,
                },
            },
        },
        sizeSmall: {
            margin: 0,
            padding: '2px',
            width: 'fit-content',
            borderRadius: '2px',
            '.MuiSwitch-switchBase': {
                '&.Mui-checked': {
                    padding: '8px 2px',
                },
                padding: '6px 2px',
                '&:hover': {
                    backgroundColor: 'transparent !important',
                },
            },
            '.MuiSwitch-track': {
                backgroundColor: basicTheme.palette.N30.main,
                width: '10px',
                height: '14px',
                borderRadius: '2px',
            },
            '.MuiSwitch-thumb ': {
                width: '10px',
                height: '6px',
                borderRadius: '2px',
                margin: '4px 0 0 0',
            },
            '.Mui-checked': {
                transform: 'translateY(-10px) !important',
            },
        },
        sizeMedium: {
            padding: '4px',
            '.MuiSwitch-thumb': {
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                margin: '3px 4px 4px 4px',
            },
            '.MuiSwitch-track': {
                width: '36px',
                height: '18px',
                borderRadius: '9px',
            },
            '.Mui-checked': {
                transform: 'translateX(18px) !important',
                '.MuiSwitch-thumb': {
                    borderColor: ` ${basicTheme.palette.N30.main} !important`,
                },
            },
            '.MuiSwitch-switchBase': {
                height: '24px',
                width: '24px',
                top: '2px',
                left: '1px',
                '&.Mui-disabled': {
                    '&:hover': {
                        backgroundColor: `transparent !important`,
                    },
                },
            },
        },
        thumb: {
            backgroundColor: basicTheme.palette.common.white,
            border: `1px solid ${basicTheme.palette.N60.main}`,
            boxShadow: 'none',
            padding: '1xpx',
            opacity: '1 !important',
        },
        track: {
            backgroundColor: basicTheme.palette.N30.main,
            opacity: '1 !important',
        },
    },
};

export { switchStyleOverride as default };
//# sourceMappingURL=MuiSwitch.js.map
